import { useVisitorCountryQuery } from '@/types/vue-apollo-helpers';

/**
 * The visitor's country as the CDN geolocated it (Cloudflare CF-IPCountry),
 * or null when the header is missing. Public: no auth or school needed.
 */
export function useVisitorCountry() {
  const { result, loading, error } = useVisitorCountryQuery({ fetchPolicy: 'cache-first' });

  const countryCode = computed(() => result.value?.visitorCountry.country_code ?? null);

  return { countryCode, loading, error };
}
